import { CREATE_STUDENT } from "./../../routes";
import customAxios from "../../customAxios";
import { ICreateStudent } from "../../../types/student.interface";
import utils from "../../../utils";

const createStudent = async (formData: ICreateStudent) => {
  console.log(formData.timing);
  try {
    return (
      await customAxios.post(CREATE_STUDENT, {
        ...formData,
        lat     : undefined,
        lng     : undefined,
        city    : undefined,
        area    : undefined,
        cycle   : undefined,
        state   : undefined,
        province: undefined,

        gender : formData.gender?.value,
        address: formData.address,

        grade        : formData.grade      ?._id,
        field        : formData.field      ?._id,
        driver       : formData.driver     ?._id,
        parent       : formData.parent     ?._id,
        school       : formData.school     ?._id,
        company      : formData.company    ?._id,
        neighborhood: formData.neighborhood?._id,
        timing: {
          sunday   : utils.convertServiceTiming.htmlToMongo(formData.timing?.sunday   ),
          friday   : utils.convertServiceTiming.htmlToMongo(formData.timing?.friday   ),
          monday   : utils.convertServiceTiming.htmlToMongo(formData.timing?.monday   ),
          tuesday  : utils.convertServiceTiming.htmlToMongo(formData.timing?.tuesday  ),
          thursday : utils.convertServiceTiming.htmlToMongo(formData.timing?.thursday ),
          saturday : utils.convertServiceTiming.htmlToMongo(formData.timing?.saturday ),
          wednesday: utils.convertServiceTiming.htmlToMongo(formData.timing?.wednesday),
        },
      })
    ).data;
  } catch (error: unknown) {
    console.error({ CREATE_STUDENT: error });
    return false;
  }
};

export default createStudent;
